import { DTypeDTOTypeEnum, MTypeDTOTypeEnum, SteelSMTypeDTOTypeEnum } from '~/api/webservice/index';
import {
  HeightOffsetVariantTypes,
  ISOPRO,
  ISOPROHeight,
  ISOPROLengths,
  ISOPROLoadBearingCapacity,
  ISOPROProductBendingMomentType,
  ISOPROProductHeightOffsetVariantType,
  ISOPROProductSMType,
  ISOPROProductSMVariantType,
  ISOPROShearForceCapacityCode,
  ISOPROType,
} from '~/models';

interface FilterISOPROProductsParams {
  type: ISOPROType | null;
  loadBearingCapacity: ISOPROLoadBearingCapacity | null;
  height: ISOPROHeight | null;
  fireProtection: boolean | null;
  shearForce: ISOPROShearForceCapacityCode<
    MTypeDTOTypeEnum | DTypeDTOTypeEnum | SteelSMTypeDTOTypeEnum
  > | null;
  length: ISOPROLengths | null;
  variant: HeightOffsetVariantTypes | null;
}

export function filterISOPROProducts (
  products: ISOPRO[],
  filterOptions: FilterISOPROProductsParams
): ISOPRO[] {
  return products.filter((p) => {
    const {
      type,
      loadBearingCapacity,
      height,
      fireProtection,
      shearForce,
      length,
      variant
    } = filterOptions;
    let rightShearForce = true;
    let rightVariant = true;

    const rightType = !type || p.type === type;
    const rightLoadBearing =
      !loadBearingCapacity || p.capacity === loadBearingCapacity;
    const rightHeight = !height || p.height === height;
    // const rightConcreteCovering = concreteCovering || p.concreteCovering === +concreteCovering;
    if (
      p instanceof ISOPROProductBendingMomentType
      || p instanceof ISOPROProductSMType
      || p instanceof ISOPROProductSMVariantType
    ) {
      rightShearForce =
        !shearForce || p.shearForceLoadBearingCapacityCode === shearForce;
    }
    const rightFireProtection =
      fireProtection === null || p.hasFireProtection === fireProtection;
    const rightLength = !length || p.properties.dimensions.length === length;
    if (
      p instanceof ISOPROProductHeightOffsetVariantType
      || p instanceof ISOPROProductSMVariantType
    ) {
      rightVariant = !variant || p.variant === variant;
    } else if (!!variant) {
      rightVariant = false;
    }

    return (
      rightType &&
      rightLoadBearing &&
      rightHeight &&
      // rightConcreteCovering &&
      rightFireProtection &&
      rightShearForce &&
      rightLength &&
      rightVariant
    );
  });
}
